
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    REBOOT_DEVICE_REQUEST,
    REBOOT_DEVICE_GET_DEVICE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { rebootDeviceResult, rebootDeviceGetDeviceResult } from 'Redux/actions';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';

function* rebootDevice({ payload }) {
    try {
        const { ids } = payload

        let QUERY = `
                mutation updateVidFleetReboot ($unitIds: [Int]!) {
                    result: updateVidFleetReboot (unitIds: $unitIds){
                        stepFunctionId
                        processStartDate
                        transactionId
                    }
                }
          `;

          let result = yield call(
            clientMutation,
            QUERY,
            {
                unitIds: ids
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (result) {
            let data = result.result
            yield put(rebootDeviceResult({ result: data }))
        }

    } catch (exc) {

        let errorResponse = exc;
        if (exc.request && exc.request.response)
            errorResponse = JSON.parse(exc.request.response)

        yield put(rebootDeviceResult({ error: errorResponse }))

        ExceptionManager(
            exc,
            "Modules/devices/.components/rebootDevice/redux/saga",
            "rebootDevice",
        )
    }
}

function* getDevice({ payload }) {
    try {
        const QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        esn
                        imei
                        deviceModel {
                            id
                            unitTypeId
                            unitType {
                                id
                                name
                                manufacturerId
                                manufacturer {
                                    id
                                    name
                                }
                                dbSchema
                                active
                            }
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                    }
                    total 
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(rebootDeviceGetDeviceResult(data?.result))
        } else {
            yield put(rebootDeviceGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(rebootDeviceGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/rebootDevice/redux/saga",
            "getDevice"
        )
    }
}

function* watchMethods() {
    yield takeEvery(REBOOT_DEVICE_REQUEST, rebootDevice);
    yield takeEvery(REBOOT_DEVICE_GET_DEVICE_REQUEST, getDevice);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}